import { render, staticRenderFns } from "./reFormResult.vue?vue&type=template&id=76151414&scoped=true&"
import script from "./reFormResult.vue?vue&type=script&lang=js&"
export * from "./reFormResult.vue?vue&type=script&lang=js&"
import style0 from "./reFormResult.vue?vue&type=style&index=0&id=76151414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76151414",
  null
  
)

export default component.exports